/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CloseCircleIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "close-circle", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.50001 15.5L15.5 9.49999", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 9.5L15.5 15.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CloseCircleIcon);
export default ForwardRef;
//# sourceMappingURL=closeCircleIcon.js.map